import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin-bottom: 15px;\n'], ['\n  margin-bottom: 15px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n      pointer-events: none;\n    '], ['\n      pointer-events: none;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: ', ';\n  margin-right: 8px;\n'], ['\n  color: ', ';\n  margin-right: 8px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: ', ';\n  cursor: pointer;\n  &:hover {\n    color: ', ';\n  }\n'], ['\n  color: ', ';\n  cursor: pointer;\n  &:hover {\n    color: ', ';\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  color: ', ';\n'], ['\n  display: flex;\n  align-items: center;\n  color: ', ';\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  ', '\n'], ['\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  ', '\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n      cursor: pointer;\n      text-decoration: underline;\n    '], ['\n      cursor: pointer;\n      text-decoration: underline;\n    ']);

import React from 'react';
import styled, { css } from 'styled-components';
import FaRetweet from 'react-icons/lib/fa/retweet';
import FaPencil from 'react-icons/lib/fa/pencil';
import FaClose from 'react-icons/lib/fa/close';
import { styles, translations } from 'gipsy-misc';
import ScheduleSelector from './components/ScheduleSelector';
import DailyInput from './components/DailyInput';
import { Options, DEFAULT_SCHEDULE, computeDefaultWeeklySchedule, computeDefaultMonthlySchedule, computeDefaultYearlySchedule } from './utils';
import WeeklyInput from './components/WeeklyInput';
import MonthlyInput from './components/MonthlyInput';
import YearlyInput from './components/YearlyInput';

var Container = styled.div(_templateObject);

var InputsContainer = styled.div(_templateObject2, function (_ref) {
  var readOnly = _ref.readOnly;
  return readOnly && css(_templateObject3);
});

var Icon = styled(FaRetweet)(_templateObject4, styles.colors.textLightColor);

var Edit = styled(FaPencil)(_templateObject5, styles.colors.textLightColor, styles.colors.textRegularColor);

var Remove = Edit.withComponent(FaClose);

var Header = styled.div(_templateObject6, styles.colors.textLightColor);

var HeaderContent = styled.div(_templateObject7, function (_ref2) {
  var active = _ref2.active;
  return active && css(_templateObject8);
});

var RecurrencyDetails = function (_React$Component) {
  _inherits(RecurrencyDetails, _React$Component);

  function RecurrencyDetails() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, RecurrencyDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = RecurrencyDetails.__proto__ || Object.getPrototypeOf(RecurrencyDetails)).call.apply(_ref3, [this].concat(args))), _this), _this.onScheduleChange = function (schedule) {
      var _this$props = _this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          when = _this$props.when;


      if (value && schedule === value.schedule) {
        return;
      }

      switch (schedule) {
        case Options.Daily:
          return onChange(DEFAULT_SCHEDULE);
        case Options.Weekly:
          return onChange({ schedule: schedule, weeklyOptions: computeDefaultWeeklySchedule(when) });
        case Options.Monthly:
          return onChange({ schedule: schedule, monthlyOptions: computeDefaultMonthlySchedule(when) });
        case Options.Yearly:
          return onChange({ schedule: schedule, yearlyOptions: computeDefaultYearlySchedule(when) });
        default:
          throw new Error('Unknown schedule ' + schedule);
      }
    }, _this.renderScheduleInput = function () {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          _onChange = _this$props2.onChange;

      switch (value.schedule) {
        case Options.Daily:
          return React.createElement(DailyInput, { value: value.dailyOptions, onChange: function onChange(dailyOptions) {
              return _onChange(_extends({}, value, { dailyOptions: dailyOptions }));
            } });
        case Options.Weekly:
          return React.createElement(WeeklyInput, { value: value.weeklyOptions, onChange: function onChange(weeklyOptions) {
              return _onChange(_extends({}, value, { weeklyOptions: weeklyOptions }));
            } });
        case Options.Monthly:
          return React.createElement(MonthlyInput, {
            value: value.monthlyOptions,
            onChange: function onChange(monthlyOptions) {
              return _onChange(_extends({}, value, { monthlyOptions: monthlyOptions }));
            }
          });
        default:
          return React.createElement(YearlyInput, { value: value.yearlyOptions, onChange: function onChange(yearlyOptions) {
              return _onChange(_extends({}, value, { yearlyOptions: yearlyOptions }));
            } });
      }
    }, _this.renderHeader = function () {
      var _this$props3 = _this.props,
          value = _this$props3.value,
          onChange = _this$props3.onChange,
          readOnly = _this$props3.readOnly,
          onRequestRecurringEdit = _this$props3.onRequestRecurringEdit;

      var content = void 0;
      if (readOnly) {
        content = React.createElement(
          HeaderContent,
          null,
          translations.taskPanel.recurrency.recurrencyDetails,
          ' ',
          React.createElement(Edit, { onClick: onRequestRecurringEdit })
        );
      } else if (!value) {
        content = React.createElement(
          HeaderContent,
          { active: true, onClick: function onClick() {
              return onChange(DEFAULT_SCHEDULE);
            } },
          translations.taskPanel.recurrency.makeRecurring
        );
      } else {
        content = React.createElement(
          HeaderContent,
          null,
          translations.taskPanel.recurrency.recurrencyDetails,
          ' ',
          React.createElement(Remove, { onClick: function onClick() {
              return onChange(undefined);
            } })
        );
      }
      return React.createElement(
        Header,
        null,
        React.createElement(Icon, null),
        content
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RecurrencyDetails, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          readOnly = _props.readOnly;

      return React.createElement(
        Container,
        null,
        this.renderHeader(),
        value && React.createElement(
          InputsContainer,
          { readOnly: readOnly },
          React.createElement(ScheduleSelector, { value: value.schedule, onChange: this.onScheduleChange, readOnly: readOnly }),
          this.renderScheduleInput()
        )
      );
    }
  }]);

  return RecurrencyDetails;
}(React.Component);

export default RecurrencyDetails;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/When/RecurrencyDetails/index.js
// module id = 488
// module chunks = 0